<div class="ai-container" #aiContainer>
  <div class="ai-landing-page">
    <ai-landing-page [isExplorePage]="true"></ai-landing-page>
  </div>
  <div class="ai-widget-initializer">
    <widget-initializer
      *ngIf="mygContext"
      [inputdata]="mygContext"
      (userSessionLoad)="widgetResizer()"
    ></widget-initializer>
  </div>
</div>
